import { Button } from "@/components/ui/button";
import usePriceLabel from "@/hooks/usePriceLabel";

export default function StickyCTA({ onClick }) {
    const priceLabel = usePriceLabel();
    return (
        <div
            className="fixed bottom-0 left-0 right-0 z-40 md:hidden px-4 pt-3 pb-4 bg-aq-cream/95 backdrop-blur-xl border-t border-aq-border shadow-[0_-8px_24px_-12px_rgba(26,42,82,0.18)]"
            data-testid="sticky-mobile-cta"
        >
            <Button
                onClick={onClick}
                data-testid="sticky-cta-button"
                className="w-full h-14 rounded-full bg-aq-gold hover:bg-aq-gold-soft text-aq-navy font-bold text-base shadow-lg active:scale-[0.99] transition-all"
            >
                Start now — {priceLabel}
            </Button>
            <p className="text-center text-[11px] text-aq-muted mt-1.5">
                Report personally reviewed by Hemangi Shah
            </p>
        </div>
    );
}
